// extracted by mini-css-extract-plugin
export var PageBanner = "pageBanner-module--PageBanner--3ePPt";
export var Triangle = "pageBanner-module--Triangle--3TX_f";
export var ShapeFill = "pageBanner-module--ShapeFill--31Ba8";